module.exports = __webpack_public_path__ + "media/images/netherlands-flag-round-e726786ff56a121a1f2f7e6be8f695e6.png";